import { useState, createContext, useContext } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const LightboxContext = createContext();

let globalOpen = null;

export function openLightbox(src, alt) {
  if (globalOpen) globalOpen({ src, alt });
}

export default function ImageLightbox() {
  const [image, setImage] = useState(null);
  globalOpen = setImage;

  return (
    <AnimatePresence>
      {image && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setImage(null)}
            className="fixed inset-0 z-[99999] bg-black/90 backdrop-blur-sm cursor-zoom-out"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
            className="fixed inset-4 sm:inset-8 z-[100000] flex items-center justify-center cursor-zoom-out"
            onClick={() => setImage(null)}
          >
            <button
              onClick={() => setImage(null)}
              className="absolute top-0 right-0 sm:top-2 sm:right-2 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors z-10"
            >
              <X size={20} />
            </button>
            <img
              src={image.src}
              alt={image.alt || ''}
              className="max-w-full max-h-full object-contain rounded-xl shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
